<template>
    <table class="colors-picker">
        <tr v-for="(color, key) in visibleColors" :key="color.name">
            <td class="colors-picker__color-name">
                {{ key.replace(/-/g, ' ') }} Color
            </td>
            <td>
                <ColorInput v-model="colors[key]" :pallet="pallet.includes(key)" @click:pallet="editPallet = key" />
            </td>
        </tr>
        <v-dialog v-model="doShowEditPallet" width="600">
            <v-card>
                <v-card-title>
                    Edit color pallet
                </v-card-title>
                <v-card-text>
                    <v-alert dense border="left" type="warning">
                        Pallet generates automatically if {{ editPallet }} color is changed. Change it in extreme cases only.<br/>
                        Make sure to use similar colors to {{ editPallet }}.
                    </v-alert>

                    <table class="colors-picker">
                        <tr v-for="(color) in palletColors" :key="color.name">
                            <td class="colors-picker__color-name">
                                {{ color.replace(/-/g, ' ') }} Color
                            </td>
                            <td>
                                <ColorInput v-model="colors[color]" />
                            </td>
                        </tr>
                    </table>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn @click="doShowEditPallet = false" color="primary">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </table>
</template>

<script>
import ColorInput from './color-input.vue'

export default {
    components: { ColorInput },

    props: {
        value: { type: Object },
        pallet: { type: Array }
    },

    data() {
        return {
            colors: { ...this.value },
            editPallet: ''
        }
    },

    computed: {
        visibleColors() {
            return Object.keys(this.colors).reduce((acc, key) => {
                if (key.includes('tint') || key.includes('shade')) { return acc }
                acc[key] = this.colors[key]
                return acc
            }, {})
        },
        doShowEditPallet: {
            get() { return !!this.editPallet },
            set(v) { this.editPallet = '' }
        },
        palletColors() {
            if (!this.editPallet) { return [] }

            return [
                'tint-2', 'tint-1', 'shade-1', 'shade-2'
            ].map((c) => `${this.editPallet}-${c}`)
        }
    },

    watch: {
        value(newValue) {
            this.colors = { ...newValue };
        },
        colors: {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) { return }
                this.$emit('input', newValue);
            },
            deep: true,
        }
    },
}
</script>

<style lang="scss" scoped>
.colors-picker {
    width: 100%;

    &__color-name {
        text-transform: capitalize;
    }

    td {
        width: 50%;
        padding: 4px;

        &:first-child {
            text-align: right;
        }
    }
}
</style>